import React from "react";
import { Scrollbars } from "react-custom-scrollbars";
import superagent from "superagent";

export default class StaticPage extends React.PureComponent {
  constructor(props) {
    super(props);
    
    this.state = {
      html: ""
    };
  }
  
  componentDidMount() {
    this.fetchPage();
  }
  
  componentDidUpdate(prevProps) {
    if (prevProps.match.path !== this.props.match.path) {
      this.fetchPage();
    }
  }
  
  fetchPage() {
    superagent.get(this.props.match.path + ".html")
      .then(
        (response) => this.setState({ html: response.text }),
        () => this.setState({ html: "not found" })
      );
  }
  
  render() {
    return (
      <Scrollbars className="static-page" style={ { height: "100%" } } hideTracksWhenNotNeeded={ true }>
        <div className="static-page__content" dangerouslySetInnerHTML={ { __html: this.state.html } }/>
      </Scrollbars>
    );
  }
}


// WEBPACK FOOTER //
// ./app/components/StaticPage/StaticPage.jsx